import * as yup from 'yup'

const iconSchema = yup
  .string()
  .trim()
  .required('Icon is required')

const paymentMethodSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().required('Name is required'),
  icon: iconSchema,
  slug: yup.string(),
  enabled: yup.boolean().required(),
})

export const customCheckoutSchema = yup.object({
  bottomSheet: yup.object({
    heading: yup.string().optional(),
    informationSections: yup.array().optional(),
    paymentMethods: yup
      .array()
      .of(paymentMethodSchema)
      .min(1, 'Add at least one payment method')
      .required()
      .test('unique-payment-method-names', 'Payment method names must be unique', function (methods) {
        if (!methods?.length) return true

        const nameCounts = new Map<string, number[]>()

        methods.forEach((method, index) => {
          const normalizedName = method?.name?.trim().toLowerCase()
          if (!normalizedName) return

          const indices = nameCounts.get(normalizedName) ?? []
          indices.push(index)
          nameCounts.set(normalizedName, indices)
        })

        const errors: yup.ValidationError[] = []

        nameCounts.forEach((indices) => {
          if (indices.length > 1) {
            indices.forEach((index) => {
              errors.push(
                this.createError({
                  path: `${this.path}[${index}].name`,
                  message: 'Payment method name must be unique',
                })
              )
            })
          }
        })

        if (errors.length) {
          throw new yup.ValidationError(errors)
        }

        return true
      }),
  }),
  qrDisplay: yup.object().optional(),
  loadingPage: yup.object().optional(),
  confirmingLoader: yup.object().optional(),
  paymentExpired: yup.object().optional(),
  refundInitiated: yup.object().optional(),
  failureMessages: yup.array().optional(),
  cancelPopup: yup.object().optional(),
})
